<template>
  <el-tabs
    type="card"
    class="tab-triangle"
    v-model="current"
    @tab-change="onTabClick"
  >
    <el-tab-pane
      v-for="item in data"
      :key="item.name"
      :label="item.name"
      :name="item.value"
    />
  </el-tabs>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue'

const props = defineProps({
  data: {
    type: Array
  }
})
const emits = defineEmits(['on-click'])

const current = ref(props.data[0].value) //当前tab

//切换tab
const onTabClick = (value) => {
  emits('on-click', value)
}
</script>

<style lang="scss" scoped>
.tab-triangle {
  &.el-tabs {
    margin-bottom: 1px;

    ::v-deep {
      .el-tabs {
        &__header {
          border: none;
          margin-bottom: 0;
        }
        &__nav {
          border: none;
        }
        &__item {
          border: none;
          background: #fff;
          color: #555;
          position: relative;
          padding-right: 2.375rem;
          font-size: 1rem;

          &:last-child {
            &.is-active {
              &::after {
                border-right-color: #f2f2f2;
                border-top-color: #f2f2f2;
              }
            }
          }
          &::after {
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            width: 0;
            height: 0;
            line-height: 0;
            font-size: 0;
            border-style: solid;
            border-color: transparent;
            // border-width: 0 22px 42px 0px;
            border-width: 0 1.375rem 3.75rem 0px;
            border-right-color: #fff;
            border-top-color: #fff;
          }
          &.is-active {
            color: #fff;
            background: linear-gradient(180deg, #0899a8, #01626b);
          }
        }
      }
    }
  }
}
</style>
